import React from 'react';
import { Helmet } from 'react-helmet';
import { isMobileOnly } from 'react-device-detect';
import { isPortraitTablet } from '../../../app';
import { ScrollToTop } from '../../../common/scripts/scroll-to-top';
import { BackLink } from '../../../common/elements/back-link/back-link';
import { PictureBlock } from '../../../common/elements/picture-block/picture-block';
import { ContentBlock } from '../../../common/elements/content-block/content-block';
import { Title } from '../../../common/elements/title/title';
import { Paragraph } from '../../../common/elements/paragraph/paragraph';

import css from './../info.module.scss';

export const ConsentCruisingGuidelines = () => {
    return (
        <ScrollToTop>
            <Helmet>
                <title>
                    Sexual Consent Policy | Nieuwezijds Gay Sauna Amsterdam
                </title>
                <meta
                    name="description"
                    content="The Consent & Cruising Guidelines of the Nieuwezijds Gay Sauna in Amsterdam."
                />
            </Helmet>
            <section className={css.root}>
                <PictureBlock />
                <ContentBlock position="2">
                    {(isMobileOnly || isPortraitTablet) && (
                        <BackLink href="/info" text="info" />
                    )}
                    <Title as="h1" text="Consent & Cruising Guidelines" />
                    <Paragraph capitals>
                        Our sauna is a place to meet, connect and explore. We
                        want everyone to feel comfortable, respected and free to
                        make their own choices.
                    </Paragraph>

                    <Paragraph capitals>
                        <strong>1. What is consent?</strong>
                        <br />
                        Consent means that everyone involved wants to
                        participate. It should be clear, mutual and freely
                        given.
                    </Paragraph>
                    <Paragraph capitals>
                        <strong>Yes means yes.</strong>
                        <br />
                        Don’t assume that someone is interested based only on
                        where they are or what they are doing.
                    </Paragraph>
                    <Paragraph capitals>
                        Consent can be communicated through words or clear,
                        active and mutual signals. If you’re unsure, pause and
                        check.
                    </Paragraph>

                    <Paragraph capitals>
                        <strong>2. How do I know someone is interested?</strong>
                        <br />
                        People communicate interest in different ways. This can
                        be a verbal yes, a clear invitation, or other obvious
                        and mutual signals.
                    </Paragraph>

                    <Paragraph capitals>
                        Silence, stillness, or simply being present do not mean
                        yes.
                    </Paragraph>

                    <Paragraph capitals>
                        Be mindful when initiating physical contact. Someone
                        allowing one type of contact does not automatically mean
                        they want another. If you’re unsure whether someone
                        wants you to approach, touch them, or join them, ask or
                        wait for a clear invitation.
                    </Paragraph>

                    <Paragraph capitals>
                        <strong>3. Cruising areas and darker spaces</strong>
                        <br />
                        Our sauna has different environments, including dark
                        rooms and darker, more private areas, where people may
                        be looking for sexual interaction and where
                        communication may often be non-verbal.
                    </Paragraph>

                    <Paragraph capitals>
                        Being in these areas can indicate that someone is open
                        to interaction, but it is not blanket consent to sexual
                        contact.
                    </Paragraph>

                    <Paragraph capitals>
                        Pay attention to the person you’re interacting with. If
                        they clearly invite you to interact, you can respond. If
                        they move away, turn away, push you away, or otherwise
                        indicate they don’t want to continue, stop and give them
                        space.
                    </Paragraph>

                    <Paragraph capitals>
                        Never assume that being in a dark room, being naked,
                        watching others, or taking part in sexual activity means
                        someone consents to sexual contact with you.{' '}
                    </Paragraph>

                    <Paragraph capitals>
                        <strong>4. Consent can change</strong>
                        <br />
                        Consent is ongoing.
                    </Paragraph>

                    <Paragraph capitals>
                        A yes to one thing is not a yes to everything. Anyone
                        can change their mind at any time.
                    </Paragraph>

                    <Paragraph capitals>
                        If someone says no, asks you to stop, or indicates they
                        no longer want to continue:
                        <br />
                        <strong>Stop. Immediately.</strong>
                    </Paragraph>

                    <Paragraph capitals>
                        Do not pressure them, ask repeatedly, or try to change
                        their mind.
                    </Paragraph>

                    <Paragraph capitals>
                        <strong>5. Look after each other</strong>
                        <br />
                        If you see someone who seems uncomfortable, overwhelmed,
                        or unable to participate freely, give them space and
                        consider checking whether they are okay.
                    </Paragraph>

                    <Paragraph capitals>
                        If you are concerned about someone’s safety —or your
                        own— contact a member of staff.{' '}
                    </Paragraph>

                    <Paragraph capitals>
                        If someone ignores your boundaries, continues after you
                        have asked them to stop, or makes you feel unsafe,
                        please tell us. We will listen, take your concern
                        seriously, and respond appropriately.
                    </Paragraph>

                    <Paragraph capitals>
                        <strong>You don’t have to deal with it alone.</strong>
                    </Paragraph>
                </ContentBlock>
            </section>
        </ScrollToTop>
    );
};
